import { Field, FieldLabel } from "@components/ui/field";
import {
  InputGroup,
  InputGroupTextarea,
  InputGroupAddon,
  InputGroupButton,
} from "@components/ui/input-group";
import {
  Item,
  ItemMedia,
  ItemContent,
  ItemTitle,
  ItemDescription,
} from "@components/ui/item";
import { useLingui, Trans } from "@lingui/react/macro";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "@components/ui/popover";
import { LightbulbIcon } from "lucide-react";
import { useState } from "react";

type OtherUseCaseProps = {
  onAdd: (description: string) => void;
  onClear: () => void;
  isActive: boolean;
  initialDescription?: string;
};

export default function OtherUseCase({
  isActive,
  onAdd,
  onClear,
  initialDescription,
}: OtherUseCaseProps) {
  const { t } = useLingui();
  const [description, setDescription] = useState(initialDescription ?? "");

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Item
            className="text-left data-[active=true]:border-violet-500 data-[active=true]:bg-violet-50 group/other-use-case"
            data-active={isActive}
            variant="outline"
            render={<button type="button" />}
          />
        }
      >
        <ItemMedia variant="icon">
          <LightbulbIcon />
        </ItemMedia>
        <ItemContent className="gap-0.5">
          <ItemTitle>
            <Trans>Annat</Trans>
          </ItemTitle>
          <ItemDescription>
            <Trans>Berätta mer</Trans>&nbsp;&rarr;
          </ItemDescription>
        </ItemContent>
      </PopoverTrigger>

      <PopoverContent className="w-(--anchor-width)">
        <Field>
          <FieldLabel htmlFor="other-use-case-description">
            <Trans>Användningsområde</Trans>
          </FieldLabel>

          <InputGroup>
            <InputGroupTextarea
              rows={5}
              autoFocus
              value={description}
              id="other-use-case-description"
              onChange={(e) => setDescription(e.target.value)}
              placeholder={t`Jag vill använda All Ears för att...`}
            />
            <InputGroupAddon align="block-end" className="justify-end">
              <PopoverClose render={<InputGroupButton variant="secondary" />}>
                <Trans>Avbryt</Trans>
              </PopoverClose>

              <PopoverClose
                render={<InputGroupButton type="button" variant="default" />}
                onClick={() => {
                  if (description) {
                    onAdd(description);
                  } else {
                    onClear();
                  }
                }}
              >
                <Trans>Klar</Trans>
              </PopoverClose>
            </InputGroupAddon>
          </InputGroup>
        </Field>
      </PopoverContent>
    </Popover>
  );
}
